export function denemePlugin() {
    console.log('Deneme Plugin eklendi!');
}